import { Component, OnInit } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { expandedSidebar, isErudaEnabled } from "src/environments/environment";
import { MainScrollService } from "./services/Common/main-scroll.service";
import { IdleUserService } from "./services/Common/idle-user.service";
import { OnlineCounterService } from "./services/online-counter";
import { HttpServiceAccount } from "./services/Authorization/http/http.service_Account";

@Component({
    selector: "app-root",
    templateUrl: "./app.component.html",
    styleUrls: ["./app.component.css"]
})
export class AppComponent implements OnInit {
    isSidebarExpanded: boolean = expandedSidebar;
    isHeaderActive: boolean = false;

    // Made a particular variable for screenTitlesMap and populated it with values in the constructor
    screenTitlesMap: Map<string, string> = new Map();

    moduleName: string;

    constructor(
        private router: Router,
        private mainScroll: MainScrollService,
        private idleUserService: IdleUserService,
        private onlineCounterService: OnlineCounterService,
        private httpServiceAccount: HttpServiceAccount,
    ) {
        this.screenTitlesMap.set("/mainsms", "אוטומציה");
        this.screenTitlesMap.set("/clients", "מאגר לקוחות");
        this.screenTitlesMap.set("/diary", "יומן");
        router.events.forEach((event) => {
            if (event instanceof NavigationEnd) {
                idleUserService.initialize();

                if (router.url.includes("/login")) {
                    // Clear the sessionStorage data if the user has logged out or token has expired 
                    sessionStorage.clear();

                    this.isHeaderActive = false;
                }
                else {
                    for (const element of this.screenTitlesMap) {
                        if (router.url.includes(element[0])) {
                            this.moduleName = element[1];
                            break;
                        }
                    }

                    this.isHeaderActive = true;
                }
            }
        });

        if (isErudaEnabled) {
            const script: HTMLScriptElement = document.createElement("script");
            script.src = "https://cdn.jsdelivr.net/npm/eruda";
            script.onload = () => {
                (window as any).eruda.init();
            };
            document.body.appendChild(script);
        }
    }

    ngOnInit(): void {
        // Online counter (when a user has logged in and refreshes the page or reopens the application, the application must connect to the socket and log in again to track users amount in the API)
        if (sessionStorage.getItem("businessUserName")) {
            this.onlineCounterService.connect(sessionStorage.getItem("businessUserName"), sessionStorage.getItem("email"), sessionStorage.getItem("password"));
            this.httpServiceAccount.postDataLoginBeautech({ login: sessionStorage.getItem("email"), password: sessionStorage.getItem("password") }).subscribe();
        }
    }

    onScroll(event: any): void {
        this.mainScroll.data = event.target.scrollTop;
    }
}